import { Component, EventEmitter, Output, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-action-menu-dropdown',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="dropdown-menu-custom shadow">

      <!-- Edit -->
      <button
        class="dropdown-item"
        (click)="emitAction('editUser')">
        <i class="fas fa-edit me-2"></i>
        Edit User
      </button>

      <!-- Delete -->
      <button
        class="dropdown-item"
        [ngClass]="{ 'text-danger': canShowDelete, 'text-muted': !canShowDelete }"
        [disabled]="!canShowDelete"
        (click)="canShowDelete && emitAction('deleteUser')"
        [title]="!canShowDelete ? 'Please inactive user first to delete' : ''">
        <i class="fas fa-trash me-2"></i>
        Delete User
      </button>

    </div>
  `,
  styles: [`
    .dropdown-menu-custom {
      background: white;
      border-radius: 6px;
      min-width: 170px;
      padding: 6px 0;
    }

    .dropdown-item {
      width: 100%;
      border: none;
      background: transparent;
      text-align: left;
      padding: 8px 14px;
      cursor: pointer;
    }

    .dropdown-item:hover {
      background: #f3f4f6;
    }
`]
})
export class UserActionMenuDropdownComponent {

  constructor(@Inject('ACTION_MENU_DATA') public data: any) {}

  @Output() actionClicked = new EventEmitter<any>();

  get canShowDelete(): boolean {
    const status = this.data?.rowData?.isActive;
    return status === false || status === 0 || status === 'false';
  }

  emitAction(action: string) {
    this.actionClicked.emit({
      action,
      rowData: this.data.rowData
    });
  }
}